import { apiBaseAssets } from "../config/api";
import lc from "../utils/language";
export const Features = ({ data, isRtl }) => {
  console.log(data);
  return (
    <div id="features" style={{ paddingTop: '60px', background: '#081526' }}>
      <div
        className="text-center"
        // style={{ backgroundColor: "#081526" }}
        style={{
          marginTop: "2rem",
          // background: 'linear-gradient(to right,rgba(127, 182, 255, 0.24) 30%, rgba(47, 128, 237, 0.24) 30% 50%, rgba(127, 182, 255, 0.24) 50% 70%, rgba(47, 128, 237, 0.24) 70%)',
          // paddingBottom: '3rem',
          // paddingTop: '3rem'
          background: 'none'
        }}
      // style={{ backgroundColor: 'rgba(47, 128, 237, 0.24)' }}
      >
        <div className="container" style={{ margin: 0, padding: 0, width: '100%', display: 'flex', flexDirection: 'column' }}>
          <div className="col-md-10 col-md-offset-1 section-title"
            style={{
              margin: 0,
              width: '100%',
              // background: 'linear-gradient(to right,rgba(127, 182, 255, 0.24) 33.33%, rgba(47, 128, 237, 0.24) 33.33% 49.98%, rgba(127, 182, 255, 0.24) 49.98% 66.63%, rgba(47, 128, 237, 0.24) 66.63%)',
            }}>
            <h2
              style={{
                // color: "#bbb",
                // marginTop: "15vh",
                fontFamily: isRtl ? "amiriBold" : "Open Sans",
              }}
            >
              {data[lc("title", isRtl)]}
            </h2>
          </div>
          <div className="row" style={{ margin: 0 }}>
            {/* {data.features
            ? data.features.map((d, i) => (
              <div key={d._id} className="col-xs-12 col-md-6 col-lg-3">
                <div className="feature-image-wrapper">
                  <img
                    src={`${apiBaseAssets}${d.background}`}
                    className="feature-image"
                  />
                </div>
                <h3 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans" }}>
                  {d[lc("title", isRtl)]}
                </h3>
                <p
                  style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans" }}
                >
                  {d[lc("subTitle", isRtl)]}
                </p>
              </div>
            ))
            : "Loading..."} */}
            <div key={data.features[0]?._id} className="col-xs-12 col-md-4 col-lg-4 pad-l" style={{ paddingTop: '3rem', height: '300px', overflow: 'hidden', textOverflow: 'ellipsis', background: 'rgba(127, 182, 255, 0.24)' }}>
              <div className="feature-image-wrapper">
                <img
                  src={`${apiBaseAssets}${data.features[0]?.background}`}
                  className="feature-image"
                />
              </div>
              <h3 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff' }}>
                {data.features[0][lc("title", isRtl)]}
              </h3>
              <p
                style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: 'rgba(242, 242, 242,0.7)' }}
              >
                {data.features[0][lc("subTitle", isRtl)]}
              </p>
            </div>

            <div key={data.features[1]?._id} className="col-xs-12 col-md-2 col-lg-2" style={{ paddingTop: '3rem', height: '300px', overflow: 'hidden', textOverflow: 'ellipsis', background: 'rgba(47, 128, 237, 0.24)' }}>
              <div className="feature-image-wrapper">
                <img
                  src={`${apiBaseAssets}${data.features[1]?.background}`}
                  className="feature-image"
                />
              </div>
              <h3 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff' }}>
                {data.features[1][lc("title", isRtl)]}
              </h3>
              <p
                style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: 'rgba(242, 242, 242,0.7)' }}
              >
                {data.features[1][lc("subTitle", isRtl)]}
              </p>
            </div>

            <div key={data.features[2]?._id} className="col-xs-12 col-md-2 col-lg-2" style={{
              paddingTop: '3rem',
              height: '300px', overflow: 'hidden',
              textOverflow: 'ellipsis', background: 'rgba(127, 182, 255, 0.24)'
            }}>
              <div className="feature-image-wrapper">
                <img
                  src={`${apiBaseAssets}${data.features[2]?.background}`}
                  className="feature-image"
                />
              </div>
              <h3 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff' }}>
                {data.features[2][lc("title", isRtl)]}
              </h3>
              <p
                style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: 'rgba(242, 242, 242,0.7)' }}
              >
                {data.features[2][lc("subTitle", isRtl)]}
              </p>
            </div>

            <div key={data.features[3]?._id} className="col-xs-12 col-md-4 col-lg-4 pad-r" style={{
              // paddingRight: '15rem',
              paddingTop: '3rem',
              height: '300px', overflow: 'hidden',
              textOverflow: 'ellipsis', background: 'rgba(47, 128, 237, 0.24)'
            }}>
              <div className="feature-image-wrapper">
                <img
                  src={`${apiBaseAssets}${data.features[3]?.background}`}
                  className="feature-image"
                />
              </div>
              <h3 style={{ fontFamily: isRtl ? "amiriBold" : "Open Sans", color: '#fff' }}>
                {data.features[3][lc("title", isRtl)]}
              </h3>
              <p
                style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: 'rgba(242, 242, 242,0.7)' }}
              >
                {data.features[3][lc("subTitle", isRtl)]}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
